// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Item_attributes_RemoverResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /so/item_attributes/remover/{id}
 *
 * Action endpoint — emits an empty success envelope (no dados payload).
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Item_attributes_RemoverResponseDados = null;

export type Item_attributes_RemoverResponse = ApiResponse<Item_attributes_RemoverResponseDados>;

registerResponseContract('Item_attributes_RemoverResponse', {})
